import { Component, OnInit } from '@angular/core';
import { LigneFinancementMarche } from '../../core/model/ligneFinancement/ligneFinancementMarche';
import { LigneFinancementMarcheService } from '../../core/service/ligne-financement/ligne-financement-marche.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditLigneFinancementMarcheComponent } from './edit-ligne-financement-marche/edit-ligne-financement-marche.component';
import { AddLigneFinancementMarcheComponent } from './add-ligne-financement-marche/add-ligne-financement-marche.component';

@Component({
  selector: "app-ligne-financement-marche",
  templateUrl: "./ligne-financement-marche.component.html",
  styleUrls: ["./ligne-financement-marche.component.scss"]
})
export class LigneFinancementMarcheComponent implements OnInit {
  ligneFinancement: LigneFinancementMarche[];

  constructor(
    private modalService: NgbModal,
    private _ligneFinancementService: LigneFinancementMarcheService
  ) {}

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this._ligneFinancementService.getAllLigneFinancementMarche().subscribe(
      data => {
        this.ligneFinancement = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  edit(ligneFinancement: LigneFinancementMarche): void {
    const modalRef = this.modalService.open(
      EditLigneFinancementMarcheComponent,
      {
        centered: true
      }
    );
    modalRef.componentInstance.ligneFinancement = ligneFinancement;

    modalRef.result.then(
      data => {
        // on close
        this.getAll();
      },
      reason => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(
      AddLigneFinancementMarcheComponent,
      {
        centered: true
      }
    );

    modalRef.result.then(
      data => {
        // on close
        this.getAll();
      },
      reason => {
        // on dismiss
      }
    );
  }
}
